// Bus Report rows summarise a school, so opening one lists that school's buses; each bus opens Bus View.
import { Box, Dialog, DialogContent, DialogTitle, IconButton, List, ListItemButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { DASHBOARD_COLORS as C, STATUS_COLORS, focusRing, statusDot } from "../DashboardCard";
import { busValidity } from "./reportConfig";

const VALIDITY = {
  expired: { color: STATUS_COLORS.rejected.color, label: "Document expired" },
  expiring: { color: STATUS_COLORS.pending.color, label: "Expiring soon" },
};

export default function SchoolBusesDialog({ school, buses = [], onClose, onOpenBus, fullScreen }) {
  return (
    <Dialog open={Boolean(school)} onClose={onClose} fullWidth maxWidth="sm" fullScreen={fullScreen} slotProps={{ paper: { sx: { borderRadius: fullScreen ? 0 : "14px" } } }}>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1, pb: 1 }}>
        <Box sx={{ minWidth: 0 }}>
          <Typography component="span" sx={{ display: "block", fontWeight: 700, fontSize: 17, color: C.navy, overflowWrap: "anywhere" }}>
            {school?.school || "School"}
          </Typography>
          <Typography component="span" sx={{ display: "block", fontSize: 13, color: C.muted }}>
            {buses.length ? `${buses.length} bus${buses.length === 1 ? "" : "es"} · select a bus to view its full details` : "Bus Report"}
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small" aria-label="Close bus list" sx={{ color: C.muted }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ borderColor: C.border, p: 1 }}>
        {buses.length === 0 ? (
          <Typography sx={{ p: 2, fontSize: 14, color: C.muted, textAlign: "center" }}>No buses are registered for this school in your report.</Typography>
        ) : (
          <List disablePadding aria-label={`Buses of ${school?.school || "school"}`}>
            {buses.map((bus, index) => {
              const status = VALIDITY[busValidity(bus)];
              return (
                <ListItemButton
                  key={bus.bus_id ?? `${bus.bus_number}-${index}`}
                  onClick={() => onOpenBus(bus)}
                  aria-label={`View ${bus.bus_number || "bus"}`}
                  sx={{ borderRadius: "10px", gap: 1.5, py: 1, minHeight: 52, "&:hover": { bgcolor: C.primarySoft }, ...focusRing }}
                >
                  <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography sx={{ fontSize: 14.5, fontWeight: 600, color: C.navy, overflowWrap: "anywhere" }}>{bus.bus_number || "Registration not updated"}</Typography>
                    <Typography sx={{ fontSize: 12.5, color: C.muted, overflowWrap: "anywhere" }}>
                      {[bus.owner_name, bus.vehicle_type].filter(Boolean).join(" · ") || "—"}
                    </Typography>
                  </Box>
                  {status && (
                    <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.75, flexShrink: 0, fontSize: 12.5, fontWeight: 600, color: status.color }}>
                      <Box component="span" sx={statusDot(status.color)} />
                      {status.label}
                    </Box>
                  )}
                  <ChevronRightRoundedIcon sx={{ color: C.muted, flexShrink: 0 }} />
                </ListItemButton>
              );
            })}
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
}
